export default __webpack_public_path__ + "static/media/useroffline.c7779c3a.svg";